import { TApiPagReq, TPagination } from "@/types/api";
import { TOption } from "@/types/common";

export const PROCEDURE_STATUS = {
  NEW_REGISTRATION: "NEW_REGISTRATION",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  OUT_OF_SCOPE: "OUT_OF_SCOPE",
} as const;

export type TProcedureStatusValue = (typeof PROCEDURE_STATUS)[keyof typeof PROCEDURE_STATUS];

export const PROCEDURE_STATUS_LABELS: TOption[] = [
  { value: PROCEDURE_STATUS.NEW_REGISTRATION, label: "新規登録" },
  { value: PROCEDURE_STATUS.IN_PROGRESS, label: "進行中" },
  { value: PROCEDURE_STATUS.COMPLETED, label: "手続き完了" },
  { value: PROCEDURE_STATUS.OUT_OF_SCOPE, label: "管理対象外" },
];

export type TProcedureStatusOption = {
  key: TProcedureStatusValue;
  label: string;
};

// 受験要件 (industry_exam_requirements) — 学習者が選択した分野に紐づく (最大3件)。
// 各要件がテーブルのチェックボックス列1つに対応する。
export type TExamProcedureStatusRequirement = {
  id: number;
  name: string;
  description: string | null;
  displayOrder: number;
};

export type TExamLearnersFilterParams = {
  fullName?: string;
  rsoCompanyIds?: string[];
  nationalityIds?: string[];
  procedureStatuses?: string[];
  nextProcedureEndDateFrom?: string;
  nextProcedureEndDateTo?: string;
  examMonthFrom?: string;
  examMonthTo?: string;
  registeredAtFrom?: string;
  registeredAtTo?: string;
};

export type TExamLearnersListReqDto = TExamLearnersFilterParams &
  TApiPagReq & {
    industryId: number;
  };

export type TExamStepLearner = {
  id: number;
  fullName: string;
  affiliatedOrganization: { id: number; companyName: string } | null;
  nationality: { id: number; nationalityName: string } | null;
  currentStatus: TProcedureStatusOption;
  statusOptions: TProcedureStatusOption[];
  isLocked: boolean;
  nextExamProcedureId: number | null;
  nextProcedureStepName: string | null;
  nextProcedureEndDate: string | null;
  nextProcedureDuration: string | null;
  examMethod: string | null;
  examMonth: string | null;
  registeredAt: string;
  remainingPeriod: string;
  prefecture: string | null;
  // チェック済みの受験要件ID一覧。examRequirements の id と突き合わせて各列のチェック状態を判定する。
  examRequirementIds: number[];
};
export type TExamLearnersResDto = {
  data: TExamStepLearner[];
  pagination: TPagination;
};
